import React, { useState, useEffect } from 'react';
import {Link, useParams} from 'react-router-dom'; // Import useParams
import './LandingPage.css';
import {Footer} from "../common/Footer";

const LandingPage = () => {
    const { receiver } = useParams(); // Get brand_name from route params
    const [backgroundImage, setBackgroundImage] = useState(
        'url("https://shop.mango.com/cms-assets/v3/assets/blt351b9b24ac05a648/blt5cfeca569132d5de/66defef251d8b23b3bd32cfe/LANDING_TAILORED_3.jpg?imdensity=1&im=RegionOfInterestCrop,width=1920,height=823,regionOfInterest=(3229.5,1144.5)")'
    );


    // Send statistics POST request on page load
    useEffect(() => {
        const sendStatistics = async () => {
            try {
                const response = await fetch('/api/statistics', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'X-Client-Token': 'Landing'
                    },
                    body: JSON.stringify({
                        page: 'landing',
                        receiver: `${receiver || 'empty'}`,
                    }),
                });
                if (!response.ok) {
                    console.error('Failed to send statistics');
                }
            } catch (error) {
                console.error('Error sending statistics:', error);
            }
        };

        sendStatistics();
    }, [receiver]);

    // Handle responsive background image
    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth <= 932) {
                setBackgroundImage(
                    'url(https://i.pinimg.com/736x/be/ac/f3/beacf3fb60eb8cac837756ee0d639de5.jpg)'
                );
            } else {
                setBackgroundImage('url(https://zametna.com/landing.jpg)');
            }
        };

        window.addEventListener('resize', handleResize);

        handleResize();

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    return (
        <div className="landing-page">
            <header
                className="landing-hero-section"
                style={{
                    backgroundImage: backgroundImage,
                }}
            >
                <nav className="landing-navbar">
                    <Link className={'landing-logo-link'} to={'/home'}>
                        <h1 className="landing-logo">zametna</h1>
                    </Link>
                    <ul className="landing-nav-links">
                    <li>
                            <a href="#partner" className="landing-smooth-scroll">Ценность</a>
                        </li>
                        <li>
                            <a href="#how-it-works" className="landing-smooth-scroll">Как это работает</a>
                        </li>
                        <li>
                            <a href="#further" className="landing-smooth-scroll">Ограниченное предложение</a>
                        </li>
                        <li>
                            <a href="#contacts" className="landing-smooth-scroll">Контакты</a>
                        </li>
                    </ul>
                </nav>
                <div className="landing-hero-content">
                    <h2>Новая концепция онлайн шоппинга</h2>
                    <p>
                        Стильные российские бренды, рилсы, образы для вдохновляющего шоппинга, инфлюенсеры, стилисты, инновационные технологии на одной площадке
                    </p>
                    <a href={`${process.env.REACT_APP_ADMIN_URL}/register`} className="link">
                        <button className="landing-cta-button">Присоединиться</button>
                    </a>
                </div>
            </header>

            <section className="landing-partner-section" id="partner">
                <h2 className="landing-partner-section-heading">Ценность Платформы</h2>
                <ul className="landing-benefits-list">

                    <li data-number="1">
                        <p className="landing-benefit-name">Миссия</p>
                        <p>Объединение лучших российских брендов на одной площадке</p>
                        <p>Повышение доверия покупателей к брендам</p>
                    </li>

                    <li data-number="2">
                        <p className="landing-benefit-name">Инновации</p>
                        <p>Система видеошоппинга, короткие видеоролики в формате рилс</p>
                        <p>Удобное мобильное приложение и сайт, анализ предпочтений покупателя, рекоммендации</p>
                    </li>

                    <li data-number="3">
                        <p className="landing-benefit-name">Продвижение</p>
                        <p>Ивенты, кросс промо кампании, онлайн шоу, коллаборации со звездами</p>
                        <p>Совместная разработка эксклюзивных коллекций</p>
                    </li>

                    <li data-number="4">
                        <p className="landing-benefit-name">Продажи</p>
                        <p>Видео - самый эффективный способ для вовлечения покупателей</p>
                        <p>Образы, видеокарточки товаров, обзоры на бренды от стилистов и инфлюенсеров</p>
                    </li>

                    <li data-number="5">
                        <p className="landing-benefit-name">Бренды</p>
                        <p>Ограниченное количество российских брендов middle-up и premium сегментов</p>
                        <p>Комфортное сотрудничество, минимальные затраты ресурсов со стороны брендов</p>
                    </li>

                    <li data-number="6">
                        <p className="landing-benefit-name">Стилисты</p>
                        <p>Топ стилисты создают уникальные образы и
                            вдохновляющие коллекции на основе партнерских брендов.</p>
                        <p>На данный момент эта услуга включена в пакет.</p>
                    </li>

                </ul>
                <a href={`${process.env.REACT_APP_ADMIN_URL}/register`} className="link">
                    <button className="landing-second-cta-button">Присоединиться</button>
                </a>
            </section>

            <section className="landing-how-it-works-section" id="how-it-works">
                <h2 className="landing-how-it-works-heading">Как это работает</h2>
                <div className="landing-steps-container">
                    <div className="landing-step">
                    <span
                        className="material-icons-outlined landing-step-icon">shopping_cart</span> {/* Shopping Icon */}
                        <h3>Загрузка коллекций</h3>
                        <p>Наша служба поддержки самостоятельно создаст все карточки товаров</p>
                    </div>
                    <div className="landing-step">
                    <span
                        className="material-icons-outlined landing-step-icon">local_offer</span> {/* Label Icon */}
                        <h3>Получайте заказы</h3>
                        <p>Товары находятся на вашем складе до момента оформления заказа</p>
                    </div>
                    <div className="landing-step">
                    <span
                        className="material-icons-outlined landing-step-icon">check_circle</span> {/* Check Icon */}
                        <h3>Подготовьте товар</h3>
                        <p>Наши курьеры для доставки и возвратов</p>
                    </div>
                </div>
                <a href={`${process.env.REACT_APP_ADMIN_URL}/register`} className="link">
                    <button className="landing-third-cta-button">Присоединиться</button>
                </a>
            </section>

            <section className="landing-exclusive-section" id="further">
                <h2 className="landing-exclusive-heading">Ограниченное предложение до <span>1 Июля</span></h2>
                <div className="landing-exclusive-benefits">
                    <p>Сниженная комиссия</p>
                    <p>Размещение на главной странице</p>
                    <p>Участие в рекламных кампаниях</p>
                    <p>Участие в подборках стилистов</p>
                    <p>Приоритетная поддержка</p>
                </div>
                <a href={`${process.env.REACT_APP_ADMIN_URL}/register`} className="link">
                    <button className="landing-exclusive-button">ПРИСОЕДИНИТЬСЯ</button>
                    <p className="landing-exclusive-note">Не упустите возможность!</p>
                </a>
            </section>

            <Footer />
        </div>
    );
};

export default LandingPage;